import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS } from '@modules/general-settings/submodules/table-columns-settings/constants';
import { useToastStore } from '@modules/toast/store';

import type { ISaveTableColumnsPayload } from '../types';
import {
  HISTORY_CHANGES_OF_TABLE_COLUMNS_QUERY,
  SAVE_TABLE_COLUMNS_API_URL,
  SAVE_TABLE_COLUMNS_MUTATION,
} from '../constants';

export default function useSaveTableColumnsMutation(): IContextMutationResult<void, Error, ISaveTableColumnsPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, ISaveTableColumnsPayload>({
    mutationKey: [SAVE_TABLE_COLUMNS_MUTATION],
    mutationFn: (payload) => fetchPost<void>(
      SAVE_TABLE_COLUMNS_API_URL,
      payload,
      {
        permission: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.EDIT,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [HISTORY_CHANGES_OF_TABLE_COLUMNS_QUERY] });
      displayPresetToast('edited');
    },
  });
}
